import { render, staticRenderFns } from "./pravila.vue?vue&type=template&id=06d2f818&scoped=true&"
import script from "./pravila.vue?vue&type=script&lang=js&"
export * from "./pravila.vue?vue&type=script&lang=js&"
import style0 from "./pravila.vue?vue&type=style&index=0&id=06d2f818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2f818",
  null
  
)

export default component.exports